import React from 'react'
import {
    FieldErrors,
    FieldValues,
    Path,
    UseFormRegister,
} from 'react-hook-form'

type Props<TFormData extends FieldValues> = {
    id: Path<TFormData>
    name: string
    placeholder: string
    register: UseFormRegister<TFormData>
    errors: FieldErrors<TFormData>
}

function TextInput<TFormData extends FieldValues>({
    id,
    name,
    placeholder,
    register,
    errors,
}: Props<TFormData>): React.JSX.Element {
    return (
        <div className="mb-4">
            <label
                htmlFor={id}
                className="block text-sm font-bold mb-1 text-[#333]"
            >
                {name}
            </label>
            <input
                id={id}
                type="text"
                placeholder={placeholder}
                {...register(id)}
                className={`form-input ${errors[id] ? 'border-red-500' : ''}`}
            />
            {errors[id] && (
                <p className="text-red-500 text-sm">
                    {errors[id].message?.toString()}
                </p>
            )}
        </div>
    )
}

export default TextInput
